var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 134,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill:#fff}.C{fill-rule:nonzero}.D{stroke-linecap:round}.E{stroke:#a4afb7}.F{stroke-linejoin:round}.G{stroke-width:1.397}.H{stroke-width:1.398}.I{fill:#a4afb7}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.98 75.275c-8.022 2.542-16.67 10.308-21.96 7.668-3.42-1.707-6.616-13.6-11.274-18.15-2.814-2.75-4.152-3.477-5.39-4.136-3.755-2-5.346-1.638-5.346-3.387 0-2.268 4.933-2.786 10.147 2.237.368.354-4.812-4.02-6.085-5.023-1.408-1.108-2.738-2.34-2.027-3.653 1.192-2.2 4.01-.432 5.886 1.844 1.657 2 3.473 4.415 2.814 3.276-1.404-2.427 2.05-4.538 3.375-4.957s3.693-.56 4.477.916c.435.817.173 1.607-.785 2.174-1.23.73-3.824 1.085-4.3 3.185-.33 1.456.607 3.04 3.01 1.24 1.465-1.096.518-2.99 2.073-4.264s3.36-.71 3.36 1.1c0 6.018-4.688 7.117-4.47 7.488 2.073 3.515 5.7 10.152 6.776 11.245 5.14 5.215 13.53-9.38 16.52-8.028",
    className: "B C D F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2cbd2",
    d: "M37.3 9.38a4.19 4.19 0 0 1 4.19 4.19V37.9a4.19 4.19 0 0 1-4.19 4.19l-1.8.01v4.162a.84.84 0 0 1-.128.445l-.07.095a.84.84 0 0 1-1.181.101L28.408 42.1l-15.537.001a4.19 4.19 0 0 1-4.19-4.19V13.57a4.19 4.19 0 0 1 4.19-4.19z"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.257,
    d: "m3.793 3.095 2.793 3.5M11.125 1v4.2M1 10.776l3.5.698",
    className: "D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.92 25.86-52.147-.818a12.24 12.24 0 0 0-9.303 4.062l-2.9 3.218a16 16 0 0 0-1.914 2.622c-1.978 3.38-2.987 5.913-3.042 7.537-.703 20.972-.86 36.2-.467 45.675q.268 6.468 1.76 11.48A16.06 16.06 0 0 0 66.3 111.115h60.045c8.87 0 16.06-7.2 16.06-16.06V45.183a16.06 16.06 0 0 0-11.076-15.267l-12.42-4.055z",
    className: "B C G"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 81.799,
    height: 81.952,
    x: 48.047,
    y: 24.253,
    className: "B C",
    rx: 21.786
  }), /*#__PURE__*/React.createElement("g", {
    className: "E G B C"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.403,
    height: 80.556,
    x: 48.745,
    y: 24.951,
    rx: 16.758
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.036 108.812.55 18.724h-1.292a2.596 2.596 0 0 0 0 5.192h4.068a3.493 3.493 0 0 0 3.493-3.493c0-.594-1.434-9.606-1.127-20.422m-29.153-.001.55 18.724h-1.292a2.596 2.596 0 0 0 0 5.192H80.9a3.493 3.493 0 0 0 3.493-3.493c0-.594-1.434-9.606-1.127-20.422",
    className: "D F"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 71.921,
    height: 71.921,
    x: 53.01,
    y: 28.93,
    fill: "#e6e9ec",
    fillOpacity: 0.7,
    className: "C",
    rx: 11.507
  }), /*#__PURE__*/React.createElement("g", {
    className: "E G"
  }, /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.964 127.586c2.7-.001 4.84 2.226 4.84 4.694H33.4c0-4.628 3.335-8.024 7.963-8.024 3.1 0 4.725 1.082 6.624 3.627.04.054-1.58 1.245-1.54 1.3-.2.424 1.37-1.597 3.517-1.598zm97.414 4.567h-7.362l-1.268-2.22-6.023-10.1-.084-.154c-.896-1.75-.653-3.896 1.097-4.792a3.23 3.23 0 0 1 4.357 1.424 5 5 0 0 1 .173.414l2.074 6.43c-.1-.562-.567-4.087-1.428-10.574a4.38 4.38 0 0 1 3.989-4.741q.279-.024.56-.012l.25.01a4.47 4.47 0 0 1 4.261 4.902l-1.915 14.544q.036 1.199 2.023-7.314a2.66 2.66 0 0 1 3.785-1.392c1.493.83 1.6 2.232.764 3.727l-5.252 9.837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.764 126.694a5.59 5.59 0 0 1 5.582 5.367l.003.218h-11.17a5.59 5.59 0 0 1 5.367-5.581l.22-.004z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.372 132.552h122.894m3.9 0h5.586m-141.328 0h5.586m-10.055 0h1.676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.296 71.665c5.477 3.2 16.66 8.085 14.07 9.774-6.7 4.374-9.157 2.803-9.157 8.07 0 9.57 6.257 10.82 9.157 8.3s.316-9.85-3.33-8.3 10.14-5.37 10.14-9.32-16.866-16.835-20.88-17.654",
    className: "B C F"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 3.352,
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.556 35.075q-3.39 2.067-4.807 5.258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.088 25.943 5.258 4.807 10.197-11.173",
    className: "F"
  })), /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.13,
    cy: 45.451,
    r: 1.327
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.596 52.937c3.58 0 6.59 3.053 6.59 7.305 0 2.072-.596 3.67-1.62 4.767a10.9 10.9 0 0 0-5.685-1.584c-1.456 0-2.846.283-4.117.797-.95-1.174-1.54-2.7-1.54-4.508 0-4.253 2.79-6.777 6.37-6.777z",
    className: "E H"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100.882,
    cy: 60.928,
    r: 2.996,
    className: "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.563 52.937c-3.58 0-6.59 3.053-6.59 7.305 0 2.072.596 3.67 1.62 4.767a10.9 10.9 0 0 1 5.685-1.584c1.456 0 2.846.283 4.117.797.95-1.174 1.54-2.7 1.54-4.508 0-4.253-2.79-6.777-6.37-6.777z",
    className: "B E H"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.277,
    cy: 59.928,
    r: 2.996,
    className: "I",
    transform: "matrix(-1 0 0 1 143.554 1)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.394,
    d: "M74.6 43.95q-9.13 2.553-9.13 4.597m34.844-4.597q9.13 2.553 9.13 4.597",
    className: "D F"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.999,
    d: "M88.415 80.868c5.056 0 8.045-2.648 10.374-4.956-2.76 1.2-4.824 2.66-10.892 2.66s-8.434-1.048-10.987-2.238c3.266 2.986 6.45 4.534 11.505 4.534z",
    className: "F I"
  }), /*#__PURE__*/React.createElement("g", {
    className: "B H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.732 78.487 4.788.25-.157 2.992a1.8 1.8 0 0 1-1.889 1.701l-1.197-.063a1.8 1.8 0 0 1-1.701-1.889l.157-2.992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.276 78.488-4.788.25.157 2.993a1.8 1.8 0 0 0 1.89 1.701l1.198-.063a1.8 1.8 0 0 0 1.701-1.89l-.156-2.991z"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.119,
    d: "M104.49 48.955q13.11.294 13.37 3.252v3.705q-1.597.506-1.816 1.854c-1.542 9.527-4.236 13.15-11.877 13.15-7.723 0-14.822-3.84-15.763-14.117q-.076-.837-2.006-.887l-.22.01q-1.713.09-1.786.878c-.94 10.278-8.04 14.117-15.763 14.117-7.64 0-10.335-3.624-11.877-13.15q-.203-1.26-1.61-1.783l-.207-.07v-3.705q.26-2.957 13.37-3.252c6.485-.146 11.384.91 14.684 2.67q1.011.54 3.083.58l.325.003q2.319 0 3.408-.582c3.3-1.76 8.2-2.815 14.684-2.67zm-34.136 3.068c-4.59-.1-7.715.117-9.076 1.91-.996 1.312-.837 3.45-.603 5.302.298 2.368 1.022 4.483 1.964 5.722 1.06 1.395 3.033 2.556 6.496 2.556 3.87 0 7.5-1.41 9.37-3.605.894-1.056 3.71-5.835 2.478-8.687-.207-.48-.735-2.96-10.628-3.196zm41.316 1.91c-1.36-1.792-4.487-2.02-9.076-1.91-9.893.237-10.42 2.716-10.628 3.196-1.23 2.853 1.584 7.63 2.478 8.687 1.86 2.196 5.5 3.605 9.37 3.605 3.463 0 5.436-1.16 6.496-2.556.942-1.24 1.666-3.354 1.964-5.722.234-1.853.393-4-.603-5.302z",
    className: "B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation1);
export default __webpack_public_path__ + "static/media/information-1.35ec10c34447be72e76d79e809654b4b.svg";
export { ForwardRef as ReactComponent };